import { render } from "./VerificationStep.vue?vue&type=template&id=23fe4f8a&scoped=true"
import script from "./VerificationStep.vue?vue&type=script&lang=js"
export * from "./VerificationStep.vue?vue&type=script&lang=js"

import "./VerificationStep.vue?vue&type=style&index=0&id=23fe4f8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fe4f8a"]])

export default __exports__